import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { ConfigurationSection } from "../StyleComponents";
import { SpaceBetweenRow } from '@shared/ui/atoms/StructuralLayout';
import Colours from '@shared/ui/atoms/Colours';
import { BodyLarge, BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { tablet } from '@shared/ui/atoms/MediaQueries';
import { selectHolidayAllowance, updateHolidayRecurringTime } from "../edit-company-page/editCompany.duck";
import { useDispatch, useSelector } from "react-redux";
import { HolidayRecurringDay } from "@features/holidays/models/Holiday.model";
import { GenericDropDownList } from '@shared/ui/molecules/GenericDropDownList';
import { useTranslation } from "react-i18next";
import moment from "moment";
import { capitalizeFirstLetter } from "@shared/utils/ArrayUtils";

interface Props {
  disabled: boolean;
  onEnableChange: (state: boolean) => any;
}

export default function HolidayYearSetting(props: Props) {
  const dispatch = useDispatch();
  const [holidayRecurringDay, setHolidayRecurringDay] = useState(HolidayRecurringDay.firstMonday);
  const [holidayRecurringMonth, setHolidayRecurringMonth] = useState(1);
  const holidayAllowanceConfig = useSelector(selectHolidayAllowance);
  const {t} = useTranslation();

  useEffect(() => {
    setHolidayRecurringDay(holidayAllowanceConfig.holidayYearRecurringDay);
    setHolidayRecurringMonth(holidayAllowanceConfig.holidayYearRecurringMonth);
  }, [holidayAllowanceConfig]);

  const onSelectionChange = (day: HolidayRecurringDay, month: number) => {
    setHolidayRecurringDay(day);
    setHolidayRecurringMonth(month);
    dispatch(updateHolidayRecurringTime({
      recurringDay: day,
      recurringMonth: month,
    }));
  }

  const START_OPTIONS = useMemo(() => {
    return [
      { name: t('general.first-monday'), id: 0 },
      { name: t('general.first-day'), id: 1 },
    ];
  }, [t]);

  const MONTHS = useMemo(() => {
    const date = moment(0);
    return [
      { name: capitalizeFirstLetter(date.format('MMMM')), id: 1 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 2 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 3 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 4 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 5 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 6 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 7 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 8 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 9 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 10 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 11 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 12 },
    ]
  }, []);

  return (
    <ConfigurationSection style={{borderBottom: 'none'}}>
      <SpaceBetweenRow>
        <BodyLarge colour={Colours.blue}>{t('settings.holiday-setting.year')}</BodyLarge>
      </SpaceBetweenRow>
      <BodyRegular style={{marginBottom: 24}}>{t('settings.holiday-setting.month')}</BodyRegular>


      <HolidayRecurringRow>
        <StartDateDropDown items={START_OPTIONS}
                           onSelect={(v: any) => onSelectionChange(v, holidayRecurringMonth)}
                           selectedId={holidayAllowanceConfig.holidayYearRecurringDay}
                           placeholder="textinput.select-start-day" />
        <StartDateDropDown items={MONTHS}
                           onSelect={(v: any) => onSelectionChange(holidayRecurringDay, parseInt(v))}
                           selectedId={holidayAllowanceConfig.holidayYearRecurringMonth}
                           placeholder="textinput.select-month" />
      </HolidayRecurringRow>
    </ConfigurationSection>
  )
}

const HolidayRecurringRow = styled(SpaceBetweenRow)`
  flex-direction: column;
  @media(${tablet}) {
    flex-direction: row;
  }
`

export const StartDateDropDown = styled(GenericDropDownList)`
  flex: 1;
  @media(${tablet}) {
    &:first-child {
      margin-right: 8px;
    }
    &:last-child {
      margin-left: 8px;
    }
  }
`
